import React from "react";

import "./styles.scss";

const RaffleButton = ({
  as: Component = "button",
  variant = "primary",
  size = "md",
  animation = false,
  className = "",
  btnBadge = null,
  children,
  ...props
}) => {
  const classes = `raffle-btn raffle-btn-${variant} raffle-btn-${size} ${
    animation ? "raffle-btn-animation" : ""
  } ${className}`.trim();

  const content = (
    <Component className={classes} {...props}>
      {animation ? <span className="button-inner">{children}</span> : children}
    </Component>
  );

  if (btnBadge) {
    return (
      <div className="raffle-btn__wrapper">
        {content}
        <div className="raffle-btn__badge">{btnBadge}</div>
      </div>
    );
  }

  return content;
};

export default RaffleButton;
